import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  root: {
    height: "100%",
    display: "flex",
    flexDirection: "column"
  },
  title: {
    color: "#595a5a",
    lineHeight: "normal",
    paddingBottom: 16,
    height: 36,
    [theme.breakpoints.down("sm")]: {
      height: 30,
      paddingBottom: 12
    }
  },
  content: {
    flexGrow: 1
  },
  hideOnDownSm: {
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  }
}));
